import AnalyticCard from "../../analyticCard/analyticCard";

const TripsCard = ({totalTrips = 88}) => {
    return(
        <ul className="grid col-4">
            <AnalyticCard color={'#5E98FF'}
                          backColor={'#EFF7FF'}
                          data={{number: totalTrips, title: <span>Total<br/> Trips</span>}}/>
            <AnalyticCard color={'#DC903A'}
                          backColor={'#FFEBC8'}
                          data={{number: 35, title: <span>Safe<br/> Trips</span>}}/>
            <AnalyticCard color={'#36BA6E'}
                          backColor={'#E3F5EA'}
                          data={{number: 37, title: <span>Best<br/> Trips</span>}}/>
            <AnalyticCard
                          data={{number: '07', title: <span>Worst<br/> Trips</span>}}/>
        </ul>
    )
}

export default TripsCard;
